import React from 'react'
import { usePlayrooms } from '../context/PlayroomsContext'
import { useBooking } from '../context/BookingContext';
import { Button } from 'antd';

export default function PackageCard({ pkg }) {

    return (
        <div
            className="bg-datepickerGray p-6 rounded-[35px] shadow-md space-y-4 flex flex-col justify-between h-full"
        >
            <div>
                <h3 className="text-2xl md:text-3xl font-bold mb-2 text-footerBlu">
                    {pkg?.packageName}
                </h3>
                <ul className="list-disc ml-5 mt-2 text-left text-footerBlue p-2 text-xs md:text-sm">
                    {pkg?.offers?.map((offer, idx) => (
                        <li key={idx}>{offer}</li>
                    ))}
                </ul>
            </div>
            <Button
                type="submit"
                disabled={true}
                className="bg-gray-400 text-footerBlue w-60 h-10 rounded-[36px] font-bold text-xl self-center"
            >
                ODABRANI PAKET
            </Button>
        </div>
    )
}
